module.exports = __webpack_public_path__ + "static/img/短视频-产品展示短视频.45e6708.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10005/短视频-产品展示短视频.png
// module id = vdCm
// module chunks = 1